var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "s-p-3"
  }, [_c('div', {
    staticClass: "reward__title py-3"
  }, [_vm._v("Les Mills 集點活動")]), _c('b-card', {
    staticClass: "reward success p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', {
    staticClass: "reward__result my-3"
  }, [_vm._v("集點成功")]), _c('div', {
    staticClass: "reward__message"
  }, [_vm._v(" 恭喜您獲得 "), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v("1")]), _vm._v(" 點 ")])]), _c('b-card', {
    staticClass: "reward fail p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', {
    staticClass: "reward__result my-3"
  }, [_vm._v("集點失敗")]), _c('div', {
    staticClass: "reward__message"
  }, [_vm._v("每人1天只能集1點唷！")])]), _c('b-card', {
    staticClass: "reward fail p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', {
    staticClass: "reward__result my-3"
  }, [_vm._v("集點失敗")]), _c('div', {
    staticClass: "reward__message"
  }, [_vm._v(" 請先"), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v("加人會員")]), _vm._v("才能集點唷！ ")])]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffRewardsCardHome'
        });
      }
    }
  }, [_vm._v("前往集點卡")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }